<template>
  <!-- 公共弹窗，不可用游戏弹窗 -->
   <div>
    <van-popup
      v-model:show="props.showGame"
      round
      position="bottom"
      class="geme_notAllow"
      :style="{ height: '70%' }"
    
      closeable
      @close="onClose"
      @open="openPop"
    >
      <h3>福利宝库搜索</h3>
      <div class="search">
        <input
          type="text"
          v-model="state.gamename"
          placeholder="输入游戏名查询"
        />
        <span @click="gameSearch">搜索</span>
      </div>
      <div class="gameList">
        <van-list
          v-model:loading="state.loading"
          :finished="state.finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-grid :gutter="8" :border="false" :center="false">
            <van-grid-item
              v-for="(item, i) in state.gameList"
              :key="i + '-list'"
              @click="onGameItem(item)"
            >
              <template #default>
                <img :src="item.pic1" alt="" />
                <h4>{{ item.gamename }}</h4>
                <p v-show="item.name_sub">{{ item.name_sub }}</p>
              </template>
            </van-grid-item>
          </van-grid>
        </van-list>
      </div>
    </van-popup>
   </div>

</template>

<script setup>
import { reactive, computed, watch } from 'vue';
import { welfareTreasureGameLists } from '../../api/welfare';

// 定义props，接收弹窗显示控制
const props = defineProps({
  showGame: {
    type: Boolean,
    required: true
  }
});

// 定义emits，向外部派发事件
const emits = defineEmits(['update:showGame', 'close' ,'gameClick']);

// 内部控制的弹窗显示，和props同步
const innerShowGame = computed({
  get() {
    return props.showGame;
  },
  set(val) {
    emits('update:showGame', val);
  }
});

const state = reactive({
  loading: false,
  finished: false,
  gameList: [],
  gamename: "",
});

// 保证分页变量响应式且适用于多次调用
let pagecode = 0;
let fetchFlag2 = false;

const openPop = async () => {
  pagecode = 1;
  state.gameList = [];
  state.finished = false;
  state.loading = true;
  await getGameList();
};

const onClose = () => {
  emits('update:showGame', false);
  emits('close');
  // 可根据业务需要清空数据或保留
};

const onGameItem = (item)=>{
  emits('update:showGame', false);
  emits('gameClick', item);
}

const gameSearch = () => {
  state.gameList = [];
  pagecode = 0;
  state.finished = false;
  onLoad();
};

const onLoad = async () => {
  pagecode++;
  await getGameList();
};

const getGameList = async () => {
  if (fetchFlag2) return;
  fetchFlag2 = true;

  try {
    let res = await welfareTreasureGameLists({
      type: "android",
      pagecode: pagecode,
      val: state.gamename,
    });
    if (res.data.code == 1) {
      state.gameList = res.data.data;
    }
    state.finished = true;
    state.loading = false;
  } catch (error) {
    state.finished = true;
    state.loading = false;
  }
  fetchFlag2 = false;
};

// 外部显隐变化后，若showGame=true自动刷新
watch(
  () => props.showGame,
  (v) => {
    if (v) {
      openPop();
    }
  }
);
</script>

<style scoped="scoped">
:deep(.van-popup) {
  border-radius: 24px 24px 0 0 !important;
}

/* 不可用游戏弹窗 */
:deep(.geme_notAllow) {
  padding: 32px;
  color: #333;
  display: flex;
  flex-direction: column;
}
:deep(.geme_notAllow) h3 {
  text-align: center;
  margin-bottom: 32px;
}
:deep(.geme_notAllow) .search {
  display: flex;
  align-items: center;
}
:deep(.geme_notAllow) .search input {
  border: none;
  flex: 1;
  height: 88px;
  background: #f7f7f7;
  border-radius: 198px;
  padding-left: 32px;
  margin-right: 32px;
  color: #333;
}
:deep(.geme_notAllow) .search span {
  font-size: 32px;
  color: #333;
}
:deep(.geme_notAllow) > h4 {
  margin: 32px 0 12px 0;
  font-size: 32px;
}
:deep(.geme_notAllow) > p {
  font-size: 20px;
  color: #999;
  margin-bottom: 28px;
}
:deep(.geme_notAllow) .gameList {
  flex: 1;
  overflow: auto;
  margin-top: 32px;
}
:deep(.geme_notAllow) .gameList .van-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  position: relative;
  flex-direction: column;
}
:deep(.geme_notAllow) .gameList .van-cell {
  width: 142px;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 20px;
}
:deep(.geme_notAllow) .gameList .van-cell__value {
  display: flex;
  flex-direction: column;
}

:deep(.van-grid-item__content) {
  width: 148px;
  height: auto !important;
  white-space: nowrap;
  align-items: center;
  padding-bottom: 24px;
  background-color: #fff;
}
:deep(.geme_notAllow) .gameList img {
  width: 120px;
  height: 120px;
  border-radius: 20px;
}
:deep(.geme_notAllow) .gameList h4 {
  font-size: 28px;
  margin: 12px 0 4px 0;
  width: 142px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
:deep(.geme_notAllow) .gameList p {
  max-width: 142px;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 4px 8px;
  font-size: 20px;
  color: #666666;
  background: #f3f4f8;
  border-radius: 6px;
}
:deep(.game_notAllow) .van-list__finished-text {
  position: absolute;
}

/* 加载框 */
.allContent :deep(.load-overlay) {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
